import {getElement, removeActive} from "./helpers.js";
import {table} from "./constants.js";


export default function userPersonalized() {
    const personalizedSection = getElement('[data-personalized]');
    if (!personalizedSection) return;
    let isInch = null;
    const saveBtn = getElement('[data-save-personalized]');
    const personalizedInputs = personalizedSection.querySelectorAll('input');
    let personalInformation = {};
    if (personalInfo && personalInfo.isSaved) {
        if (personalInfo.pa_color && getElement(`[data-pa_color="${personalInfo.pa_color}"]`)) {
            getElement(`[data-pa_color="${personalInfo.pa_color}"]`).classList.add('active');
        }
        isInch = personalInfo.isInch
        Object.keys(personalInfo.info).forEach(key => {
            if (personalInfo.info[key]) {
                getElement(`#${key}`).value = personalInfo.info[key]
            }
        })

    }
    getElement('[data-pa_color]', true).forEach(colorBtn => {
        colorBtn.addEventListener('click', (e) => {
            if (colorBtn.classList.contains('active')) {
                colorBtn.classList.toggle('active');
            } else {
                removeActive(getElement('[data-pa_color]', true));
                colorBtn.classList.add('active');
            }
        })
    })
    removeActive(getElement('[data-system]', true));
    if (isInch) {
        getElement('[data-system="imperial"]').classList.add('active')
        renderActiveMetricSystemValue(getElement('[data-system="imperial"]'));
    } else {
        getElement('[data-system="metric"]').classList.add('active')
        renderActiveMetricSystemValue(getElement('[data-system="metric"]'));
    }

    getElement('[data-system]', true).forEach(switchItem => {

        switchItem.addEventListener('click', () => {
            removeActive(getElement('[data-system]', true));
            switchItem.classList.add('active');
            renderActiveMetricSystemValue(switchItem);
            isInch = switchItem.dataset.system == 'metric' ? false : true;
            personalizedInputs.forEach(input => {
                let value = +input.value;
                if (value) {
                    switch (input.name) {
                        case 'height':
                            // console.log(isInch ? MyRound10(value * 30.48) :  MyRound10(value / 30.48) )
                            input.value = isInch ? Math.round(value / 30.48) : Math.trunc(value * 30.48);
                            break;
                        case 'weight':
                            input.value = isInch ? Math.round(value * 2.205) : Math.round(value / 2.205);
                            break;
                        default:
                            input.value = isInch ? Math.round(value / 2.54) : Math.round(value * 2.54);
                            break;
                    }
                }
            })
        })
    })
    saveBtn.addEventListener('click', () => {
        personalInformation.isInch = isInch;
        let size = {}
        personalInformation.info = {};
        personalInformation.personalized = {};
        personalizedInputs.forEach(input => {
            if (input.value) {
                personalInformation.info[input.name] = input.value;
                if (isInch) {
                    switch (input.name) {
                        case 'height':
                            size[input.name] = Math.ceil(+input.value * 30.48);
                            break;
                        case 'weight':
                            size[input.name] = Math.ceil(+input.value / 2.205);
                            break;
                        default:
                            size[input.name] = Math.ceil(+input.value * 2.54);
                            break;
                    }
                } else {
                    return size[input.id] = input.value;
                }
            }
        });
        Object.keys(table).forEach(key => {
            let sizeItem = JSON.parse(JSON.stringify(table[key]));
            if (Object.keys(sizeItem).length) {
                if (sizeItem.set) {
                    delete sizeItem.set
                }
                let sizeValue = findProductSize(sizeItem, size);
                if (sizeValue) {
                    if (['femaleVestBodySizeVest', 'femaleVestBodySizeCummerband', 'vestBodySizeCummerband', 'vestBodySizeVest', 'panelSize', 'bodySizeCummerband', 'bodySizeVest'].includes(key)) {
                        return personalInformation.personalized[key] = sizeValue.slice(0, -1)
                    } else {
                        return personalInformation.personalized[key] = sizeValue
                    }
                }
            }
        })
        if (!personalInformation.isSaved) personalInformation.isSaved = true;
        personalInformation.pa_color = getElement('[data-pa_color].active').dataset.pa_color;
        saveBtn.innerText = 'Saving...';
        saveBtn.classList.add('disabled');
        // console.log(personalInformation)
        savePersonalized(personalInformation, saveBtn);
    })


}

async function savePersonalized(query, btn) {
    let data = {
        'action': 'uarm_add_personalized',
        'data': query
    }

    let response = await fetch(`${ajax_url}`, {
        method: 'POST',
        body: JSON.stringify(data),
        headers: {
            "Content-Type": "application/json",
        },
    });
    try {
        if (response.ok) {
            setTimeout(() => {
                btn.innerText = 'Saved';
            }, 500)

            setTimeout(() => {
                btn.classList.remove('disabled');
                btn.innerText = 'Save';
            }, 1000)
        }
    } catch (e) {
        console.log(e);
    }
}

function renderActiveMetricSystemValue(element) {
    getElement(`[data-${element.dataset.system}]`, true).forEach(system => {
        system.querySelector('span').innerText = system.getAttribute(`data-${element.dataset.system}`)
    })
}

function findProductSize(sizeItem, size) {
    return Object.keys(sizeItem).find(el => {
        for (let k in sizeItem[el]) {
            return Object.keys({...sizeItem[el]}).every(k => {
                if (size[k] && sizeItem[el][k] && size[k] >= sizeItem[el][k][0] && size[k] <= sizeItem[el][k][1]) {
                    return el;
                }
            })
        }
    })
}

